import { staticUrl } from "./baseUrl";

export const getProductImages = (product) => {
  if (!(product && Object.keys(product).length)) return [];
  let itemImages = [];
  const baseUrl = staticUrl + "/";
  if (product?.image) {
    itemImages.push({
      original: baseUrl + product.image,
      thumbnail: baseUrl + product.image,
    });
  }
  if (
    product &&
    product?.additionalImages &&
    product?.additionalImages.length > 0
  ) {
    product?.additionalImages?.forEach((image) => {
      // Handle different formats: string, object with name, object with url
      let imagePath;
      if (typeof image === 'string') {
        imagePath = image;
      } else if (image && typeof image === 'object') {
        // Prefer url property over name property for full URLs
        imagePath = image.url || image.name;
      }

      if (imagePath) {
        // If it's already a full URL, use it directly; otherwise prepend baseUrl
        const fullUrl = imagePath.startsWith('http') ? imagePath : baseUrl + imagePath;
        itemImages.push({
          original: fullUrl,
          thumbnail: fullUrl,
        });
      }
    });
  }
  return itemImages;
};

export const getDate = (date) => {
  return new Date(date).toLocaleDateString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
  });
};

export const getParsedVariations = (variation) => {
  try {
    if (!variation) return { parsed: [], formatted: '' };

    if (Array.isArray(variation)) {
      const formatted = variation
        .map(item => `${item.name}: ${item.value}`)
        .join(', ');
      return { parsed: variation, formatted };
    }
  
    if (typeof variation === 'string') {
      const parsed = JSON.parse(variation);
      if (Array.isArray(parsed)) {
        const formatted = parsed
          .map(item => `${item.name}: ${item.value}`)
          .join(', ');
        return { parsed, formatted };
      }
    }
    return { parsed: [], formatted: '' };
  } catch (error) {
    console.warn('Variation parsing failed:', error);
    return { parsed: [], formatted: '' };
  }
};

export const getYouTubeId = (url) => {
  if(!url) return null;
  const match = url.match(/[?&]v=([^&]+)/);
  return match ? match[1] : null;
};

export const checkCODEnabled = (items) => {
  if(!items || items.length === 0) return false;
  
  if(items.every(item => item?.product?.cod === true)) return true;

  return false;
};

// Format store name - ensures first letter is capitalized while preserving original capitalization
export const formatStoreName = (name) => {
  if (!name) return "Unknown Seller";
  // If first character is already uppercase, return as-is to preserve original formatting
  // Otherwise, capitalize first letter only
  if (name.charAt(0) === name.charAt(0).toUpperCase()) {
    return name;
  }
  return name.charAt(0).toUpperCase() + name.slice(1);
};